import { RequireExactlyOne } from "type-fest";

import { BookingDataItem } from "../booking_form.types";

type AdditionalData = { id: undefined } | { bookingTemplateId: undefined };
type Source = { start_date: string; end_date: string } & RequireExactlyOne<{
  id: number;
  bookingTemplateId: number;
}>;

export const mapBookings = (bookings: BookingDataItem[], additionalData: AdditionalData, source?: Source) =>
  bookings.map((booking) => ({
    ...booking,
    ...additionalData,
    ...(source
      ? {
          ...("id" in source ? { id: source.id } : {}),
          ...("bookingTemplateId" in source ? { bookingTemplateId: source.bookingTemplateId } : {}),
          startDate: source.start_date,
          endDate: source.end_date
        }
      : {})
  }));
